import { FooterMenu } from './footer-menu';
import { SocialMenu } from './social-menu';
import React, { RefObject } from 'react';

export const Footer: React.FC<FooterProps> = (props) => {
  const customAction = (action: string) => {
    switch (action) {
      case 'cookie_preferences':
        try {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          UC_UI.showSecondLayer();
        } catch (e) {
          console.error(e);
        }
        break;

      default:
        break;
    }
  };

  return (
    <footer className="cue-project-footer" ref={props.footerRef}>
      <div className="cue-project-footer-inner">
        <nav className="cue-project-footer-menu cue-project-footer-menu-top">
          <FooterMenu slug="footer-menu-right" onCustomAction={customAction} />
        </nav>
        <nav className="cue-project-footer-menu cue-project-footer-menu-bottom-left">
          <FooterMenu slug="footer-menu-left" onCustomAction={customAction} />
        </nav>
        <nav className="cue-project-footer-menu cue-project-footer-menu-bottom-center">
          <FooterMenu slug="footer-menu-bottom" onCustomAction={customAction} />
        </nav>
        <nav className="cue-project-footer-menu cue-project-footer-menu-bottom-right">
          <SocialMenu slug="social-menu" />
        </nav>
      </div>
    </footer>
  );
};
export interface FooterProps {
  path: string;
  styling?: string;
  footerRef: RefObject<HTMLElement> | null;
}
